/* tslint:disable */
/* eslint-disable */

/**
 * Mail types Enum for Messaging (manually registered in swagger)
 */
export enum WorkMailTypeNamesEnum {
  Privat = 'Privat',
  Geschaft = 'Gesch\xE4ft'
}
